var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"chart-root"}},[_c('chart',{ref:"chart",staticClass:"chart",staticStyle:{"height":"200px","overflow":"hidden"},attrs:{"options":_vm.options,"auto-resize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }